module.exports = __webpack_public_path__ + "static/media/LoginEstrellas.05d2b99c.png";